import '@src/assets/scss/ntts-tokens.css'
import './ntts-spinner.scss'

/**
 * In-page loading spinner (NTTS ring). Drop-in: existing <Spinner /> usages
 * need no changes.
 *
 * @param {string} props.label  optional caption under the ring (e.g. "Loading reviews")
 * @param {'sm'|'md'|'lg'} props.size  ring size (default 'md')
 * @param {boolean} props.fullPage  centre in the content area (route/page loads)
 */
const ComponentSpinner = ({ label, size = 'md', fullPage = false }) => {
  return (
    <div
      className={`ntts-loader ${fullPage ? 'ntts-loader--page' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`ntts-spinner ${size !== 'md' ? `ntts-spinner--${size}` : ''}`}
        aria-hidden="true"
      />
      {label ? (
        <span className="ntts-loader__label">{label}</span>
      ) : (
        <span className="visually-hidden">Loading…</span>
      )}
    </div>
  )
}

export default ComponentSpinner
